export class Show {
  static readonly type = '[Snackbar] Show';

  constructor(public message: string, public time?: number, public dismissable?: string) {}
}
